import React, { useState, useEffect, useRef, useContext } from "react";
import { Row, Container, Button } from "react-bootstrap";
import DemoParinted from "../../../../../templates/ApplicationDetails/components/RichTextArea";
import { ScrutinyRemarksContext } from "../../../../Context/remarks-data-context";
import DialogContentModal from "../../../../../templates/ApplicationDetails/components/DialogContent";
import Notesheet from "./ApplicationNoting";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { ConvertEpochToDate } from "@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";

const HistoryList = ({ formData, callNotingDetailsAPI, developerRemarks, setDeveloperRemarks, notingRemarksData, logoData }) => {
  const context = useContext(ScrutinyRemarksContext);
  // const { notingRemarksData = null, handleGetFiledsStatesById = () => {} } = context || {};
  const windowHeight = window !== undefined ? window.innerHeight : null;
  const applicationStatus = formData?.status;
  const [remarkDataResp, setRemarkDataResp] = useState();
  const [, setIsPreviewLoading] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const [smShowMsNoting, setSmShowMsNoting] = useState(false);
  const [disapprovedList, setDisapprovedList] = useState([]);
  const [loader, setLoader] = useState(false);
  const isDA = formData?.department === "DA";
  const isLandUse = formData?.applicationType === "FORM_LANDUSE";
  const authority = isLandUse ? formData?.location1?.toUpperCase() : formData?.locationDistrict?.toUpperCase();
  // const [developerRemarks, setDeveloperRemarks] = useState(null);
  const [hasFetchedFields, setHasFetchedFields] = useState(false);
  const boundaryKey = isLandUse ? formData?.location1 : formData?.locationDistrict;
  const currentLogoId = isDA ? logoData?.boundary?.find((item) => item.name === boundaryKey)?.fileStoreId : logoData?.fileStoreId;
  const caption = {
    date: Digit.DateUtils.ConvertTimestampToDate(formData?.auditDetails?.createdTime),
    source: formData?.channel || "",
  };
  console.log(authority, formData, logoData, "logoData in history list", currentLogoId, isDA);

  const fetchLogoUrl = async () => {
    console.log("insideFetchURLLogo", currentLogoId);
    if (!currentLogoId) return;

    const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
    setLogoUrl(result);
  };
  const userInfo = Digit.UserService.getUser()?.info || {};
  const Modal = useModal();
  const authToken = Digit.UserService.getUser()?.access_token || null;
  const userRolesArray = userInfo?.roles.filter((user) => user.code !== "EMPLOYEE");
  const filterDataRole = userRolesArray?.[0]?.code;
  const designation = userRolesArray?.[0]?.name;

  console.log("UserINFOD", userInfo, userRolesArray, filterDataRole, designation);

  const nameOfDepartment = isDA ? `${authority} DEVELOPMENT AUTHORITY` : "AWAS EVAM VIKAS PARISHAD";
  const conponentPDF = useRef();
  useEffect(() => {
    if (remarkDataResp && remarkDataResp.length) {
      const disapprovedRemarks = remarkDataResp.filter((ele) => ele?.performaFieldDetail?.[0]?.isApproved === "disapproved");
      setDisapprovedList(disapprovedRemarks);
    }
  }, [remarkDataResp]);

  useEffect(() => {
    if (designation && notingRemarksData && notingRemarksData?.SecurityReport && notingRemarksData?.SecurityReport?.length > 0) {
      let item = notingRemarksData?.SecurityReport?.find((item) => item?.userDesignation === designation);
      if (item) {
        Digit?.SessionStorage.set("isNotingValidated", true);
      }
    }
  }, [designation, notingRemarksData]);

  const [content, setContent] = useState("");
  const [error, setError] = useState(false);
  // const editor = useRef(null);
  // const config = {
  //   readonly: false,
  //   height: 400
  // };
  const handleUpdate = (event) => {
    const editorContent = event.target.innerHTML;
    setContent(editorContent);
  };

  const [post, setPost] = useState({
    // title: '',
    content: "",
    hearingDate: "",
    // categoryId: ''
  });

  const handleViewDocument = (docId) => {
    if (docId) {
      console.log(`Viewing document with ID: ${docId}`);
      // Simulate document view logic
      alert(`Document with ID: ${docId} viewed!`);
    } else {
      alert("No document available");
    }
  };
  useEffect(() => {
    fetchLogoUrl();
  }, [currentLogoId, logoData, formData]);

  // const handlemodalsubmit = async () => {
  //   setLoader(true)
  //   const postData = {
  //     requestInfo: {
  //       api_id: "1",
  //       ver: "1",
  //       ts: null,
  //       action: "create",
  //       did: "",
  //       key: "",
  //       msg_id: "",
  //       requester_id: "",
  //       authToken: authToken,
  //     },
  //     egScrutiny: {
  //       applicationId: formData?.applicationNo,
  //       comment: developerRemarks,
  //       fieldValue: "dateValue",
  //       fieldIdL: "NOTING_BOARD",
  //       isApproved: "NOTING_BOARD",
  //       isLOIPart: "",
  //       userid: userInfo?.id || null,
  //       serviceId: 123,
  //       documentId: null,
  //       bussinessServiceName: formData?.businessService,
  //       designation: designation,
  //       name : userInfo?.name || null,
  //      employeeName : userInfo?.name || null,
  //       role: filterDataRole,
  //       applicationStatus: formData?.status
  //     },
  //   };

  //   try {
  //     const Resp = await axios.post("/land-services/egscrutiny/_create?status=submit", postData, {}).then((response) => {
  //       console.log("log1223",Resp,response.data);
  //       return response.data;

  //     });
  //     setLoader(false);
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   Modal(
  //     `Application Noting `,
  //     `Application <strong>(${formData?.applicationNo}) Noting </strong>Successfully!`,
  //     "success",

  //     window.location.pathname
  //   );
  //   await handleGetFiledsStatesById(formData?.applicationNo)

  // };

  useEffect(() => {
    if (developerRemarks?.trim()?.length > 0) {
      setError(false);
    }
  }, [developerRemarks]);

  const handlemodalsubmit = async () => {
    if (developerRemarks.trim() === "") {
      setError(true);
      return;
    } else {
      setLoader(true);
      Digit?.SessionStorage.set("isNotingValidated", developerRemarks.trim()?.length > 0);
      callNotingDetailsAPI();
    }
  };

  const closeModalHistory = (item) => {
    if (item?.applicationNo != null) {
      setSmShowMsNoting(true);
    } else {
      console.log("Application Number Null CLU");
    }
  };

  console.log("NOTINGREMARKSDATA", notingRemarksData);
  console.log("formData", formData);

  const sortDataWithTime = (data) => {
    const sortedData = Array.isArray(data) ? [...data].sort((a, b) => a.auditDetails.lastModifiedTime - b.auditDetails.lastModifiedTime) : [];
    return sortedData;
  };

  return (
    <Container
      className="justify-content-center"
      style={{
        top: windowHeight * 0.3,
        minWidth: "100%",
        maxWidth: "100%",
        maxHeight: "50%",
        minHeight: "40%",
        marginTop: 5,
      }}
    >
      <Row className="remarkshelp">
        <div class="concludingremarks">
          <DemoParinted setContent={setDeveloperRemarks} content={developerRemarks}></DemoParinted>
          {error && (
            <div
              style={{
                marginTop: "10px",
                color: "red",
              }}
            >
              Please Enter Remarks.
            </div>
          )}
          <Button
            className="submit-bar submit-bar-take-action"
            style={{
              marginLeft: 20,
              color: "#fff",
              textAlign: "center",

              backgroundColor: applicationStatus === "APPROVED" ? "grey" : "rgb(31 74 124)",
            }}
            onClick={handlemodalsubmit}
            disabled={applicationStatus === "APPROVED"}
          >
            Save
          </Button>
        </div>
        <div className="histrorynotingremarks" id="historyList">
          <Button
            className="submit-bar submit-bar-take-action"
            style={{ marginLeft: 20, color: "#fff", textAlign: "center" }}
            onClick={() => closeModalHistory(formData)}
          >
            <span style={{ color: "#fff" }}>View</span>
          </Button>
          <div ref={conponentPDF} class="notesheet">
            {/* <header class="notesheet-header">
              <div class="logo">
                <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" alt="Logo" class="logo-image" />
              </div>
              <div class="authority-name">
                <h1>Lucknow Development Authority</h1>
                <h2>NOTESHEET</h2>
              </div>
            </header> */}

            <div style={{ display: "flex", padding: "5px", background: "rgb(230, 239, 248)" }}>
              <div style={{ background: "white", borderRadius: "50%" }}>
                <img width="60" height="30" src={logoUrl} alt="Uttar-Pradesh-Logo" />
              </div>
              <div style={{ color: "#1f4a7c" }}>
                <p style={{ marginLeft: "12px", fontSize: "1.25rem", fontWeight: "600", fontFamily: '"Calibri", sans-serif' }}>{nameOfDepartment}</p>
                <p style={{ marginLeft: "12px", fontFamily: '"Calibri", sans-serif', fontWeight: "500" }}>Government of Uttar Pradesh</p>
              </div>
            </div>

            <section class="proposal-details">
              <h3>Proposal Details</h3>
              <div class="row">
                <div class="col-12">
                  <strong>File Number:</strong>
                  {formData?.applicationNo}
                </div>
                <div class="col-12">
                  <strong>Submitted On:</strong>
                  {caption?.date}{" "}
                </div>

                <div class="col-12">
                  <strong>Application Type:</strong> {formData?.applicationType}
                </div>
                <div class="col-12">
                  {" "}
                  <strong>License No :</strong>
                  {formData?.professionalInformation?.licenseNumber}
                </div>
                {formData?.professionalInformation?.consultantCategory && (
                  <div class="col-12">
                    <strong>{formData?.professionalInformation?.consultantCategory}:</strong> {formData?.professionalInformation?.name}
                  </div>
                )}
                {formData?.professionalInformation?.consultantCategory && (
                  <div class="col-12">
                    {" "}
                    <strong>{formData?.professionalInformation?.consultantCategory} Mobile:</strong> {formData?.professionalInformation?.mobileNumber}
                  </div>
                )}
                <div class="col-12">
                  {" "}
                  <strong>Owners Name:</strong> {formData?.landInfo?.owners?.[0].name}
                </div>
                <div class="col-12">
                  {" "}
                  <strong>Owners Mobile:</strong> {formData?.landInfo?.owners?.[0].mobileNumber}
                </div>
              </div>

              <div></div>
            </section>

            <section class="remarks-table">
              <table>
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Officers Name</th>
                    <th>Designation</th>
                    <th>Officers Remarks</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {sortDataWithTime(notingRemarksData?.SecurityReport)
                    ?.reverse()
                    ?.map((item, index) => {
                      const date = ConvertEpochToDate(item?.auditDetails?.createdTime);
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item?.userName}</td>
                          <td>{item.userDesignation}</td>
                          <td>
                            {/* documentDetails */}
                            {item.detailDataRemarks?.[0]?.documentDetails?.developerRemarks && (
                              <React.Fragment>
                                <strong>Document Remarks :</strong>
                                <p>
                                  <SafeHtml html={item.detailDataRemarks?.[0]?.documentDetails?.developerRemarks} />
                                </p>
                              </React.Fragment>
                            )}

                            {item.detailDataRemarks?.[0]?.khasraRemarks && (
                              <React.Fragment>
                                <strong>Land Use Remarks :</strong>
                                <p>
                                  <SafeHtml html={item.detailDataRemarks?.[0]?.khasraRemarks} />
                                </p>
                              </React.Fragment>
                            )}

                            {item.detailDataRemarks?.[0]?.drawingsDetails?.developerRemarks && (
                              <React.Fragment>
                                <strong>Drawings Remarks :</strong>
                                <p>
                                  <SafeHtml html={item.detailDataRemarks?.[0]?.drawingsDetails?.developerRemarks} />
                                </p>
                              </React.Fragment>
                            )}

                            {item?.detailDataRemarks?.[0]?.inspectionDetails?.inspectionReportData?.developerRemarks && (
                              <React.Fragment>
                                <strong>Inspection Remarks :</strong>
                                <p>
                                  <SafeHtml html={item?.detailDataRemarks?.[0]?.inspectionDetails?.inspectionReportData?.developerRemarks} />
                                </p>
                              </React.Fragment>
                            )}

                            {item.detailDataRemarks?.[0]?.paymentDetails?.developerRemarks && (
                              <React.Fragment>
                                <strong>Payment Remarks :</strong>
                                <p>
                                  <SafeHtml html={item.detailDataRemarks?.[0]?.paymentDetails?.developerRemarks} />
                                </p>
                              </React.Fragment>
                            )}

                            {item.detailDataRemarks?.[0]?.notingDetails?.developerRemarks && (
                              <React.Fragment>
                                <strong>Noting Remarks :</strong>
                                <p>
                                  <SafeHtml html={item.detailDataRemarks?.[0]?.notingDetails?.developerRemarks} />
                                </p>
                              </React.Fragment>
                            )}

                            {/* <div
                    dangerouslySetInnerHTML={{
                      __html: item.comment || "No Remarks",
                    }}
                  /> */}
                          </td>
                          <td>
                            {/* <FormattedDate timestamp={item.createdOn} /> */}
                            {date}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </section>
          </div>
        </div>
      </Row>

      <DialogContentModal
        title={"Application Noting"}
        dataOpen={smShowMsNoting}
        onClose={() => {
          setSmShowMsNoting(false);
        }}
      >
        <Notesheet
          formData={formData}
          notingRemarksData={notingRemarksData}
          caption={caption}
          // conponentPDF={conponentPDF}
          logoUrl={logoUrl}
          nameOfDepartment={nameOfDepartment}
        />
      </DialogContentModal>
    </Container>
  );
};

export default HistoryList;
